import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import type { InventoryStatusString } from '../../@types/ElasticVehicle';
import { prettify } from '../../helpers/prices';
import { getItemPrice } from '../../selectors/item';
import PriceRow from './price-row';

interface PriceProps {
  inventoryStatus?: InventoryStatusString;
}

const Price = ({ inventoryStatus }: PriceProps) => {
  const { t } = useTranslation('common');
  const data = useSelector(getItemPrice);

  if (!data) return null;

  const { price, oldPrice, deductibleVat } = data;

  if (!price) {
    return null;
  }

  const shouldDisplayOldPrice = (oldPrice || 0) > price;

  return (
    <div className="convert-card-section">
      <div data-wx-pricelist="">
        <PriceRow
          title={
            inventoryStatus === 'Order'
              ? t('priceLabel.recommendedRetailPrice', { ns: 'common' })
              : t('priceLabel.cash', { ns: 'common' })
          }
          value={prettify(price, 'kr')}
          shouldIndicateReducedPrice={shouldDisplayOldPrice}
          isReducedPrice={false}
        />
        {!!oldPrice && shouldDisplayOldPrice && (
          <PriceRow
            title={t('priceLabel.earlier', { ns: 'common' })}
            value={prettify(oldPrice, 'kr')}
            shouldIndicateReducedPrice={false}
            isReducedPrice={true}
          />
        )}
        {deductibleVat && (
          <PriceRow
            title={t('priceLabel.excludingVat', { ns: 'common' })}
            value={prettify(price * 0.8, 'kr')}
            shouldIndicateReducedPrice={false}
            isReducedPrice={false}
          />
        )}
      </div>
    </div>
  );
};

export default Price;
